export default __webpack_public_path__ + "static/media/pauseTimer.d73c4745.mp3";